import type { AccordionTitle } from '@/components/molecules/AccordionCard/types';
import type { FunctionComponent } from 'react';

import { ctw } from '@/common';
import { CardHeader, CardTitle } from '@/components';

export const AccordionCardTitle: FunctionComponent<AccordionTitle> = ({
  className,
  children,
  cardTitleProps,
  leftChildren,
  rightChildren,
  ...props
}) => {
  return (
    <CardHeader {...props} className={ctw(`pb-2`, className)}>
      {leftChildren}
      <CardTitle {...cardTitleProps} className={ctw(`text-xl`, cardTitleProps?.className)}>
        {children}
      </CardTitle>
      {rightChildren}
    </CardHeader>
  );
};

AccordionCardTitle.displayName = 'Accordion.Title';
